<template>
  <div>
    <div>
      <div v-if="isAdmin" class="hero-img hidden-sm-and-down mt-n12"></div>

      <loader v-if="!pageLoaded"></loader>

      <v-row v-else class="fill-height">
        <v-col cols="12">
          <v-layout wrap class="info-cards px-4 my-6 mt-n1">
            <v-flex sm12 md4 class="px-2 my-4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="secondary-top-border info-card"
                  style="width: 100%"
                  :elevation="hover ? 10 : 2"
                  link
                  :to="{ name: 'awards.index' }"
                  exact
                  v-ripple="false"
                >
                  <v-list class="grey lighten-4">
                    <v-list-item>
                      <v-list-item-content>
                        <div class="d-flex justify-space-between">
                          <span
                            class="blue-grey--text text--darken-2 text-uppercase"
                          >Awards</span>
                          <v-icon color="accent" large>mdi-trophy-variant-outline</v-icon>
                        </div>
                        <v-list-item-title>
                          <span
                          class="display-1 font-weight-light blue-grey--text text--darken-4 pb-n2"
                          :class="awardsQty !== awardsDefaultQty ? 'opacity-06' : null"
                          >{{ awardsQty.toLocaleString('fr-FR') }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-card-text>
                    <v-list class="mb-10">
                      <div class="text-h6 primary-title primary--text mb-3">Recent Updated Awards</div>

                      <v-list-item
                        v-for="item in awards" :key="item.id"
                        link
                        exact
                        :to="{ name: 'awards.edit', params: { id: item.id } }"
                      >
                        <v-list-item-action class="list-avatar d-flex justify-center">
                          <img
                            v-if="item.image"
                            :src="`${baseURL}/img/awards/64/${item.image}`"
                          >
                          <v-avatar v-else color="blue-grey lighten-5">
                            <span class="blue-grey--text text--darken-1">
                              {{ item.name | capitalizeName }}
                            </span>
                          </v-avatar>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <v-list-item-subtitle class="caption">Updated {{ moment(item.updated_at).format('L') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-btn
                    link
                    :to="{ name: 'awards.create' }"
                    absolute
                    dark
                    fab
                    bottom
                    right
                    color="primary"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card>
              </v-hover>
            </v-flex>

            <v-flex sm12 md4 class="px-2 my-4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="secondary-top-border info-card"
                  style="width: 100%"
                  :elevation="hover ? 10 : 2"
                  link
                  :to="{ name: 'laureates.index' }"
                  exact
                  v-ripple="false"
                >
                  <v-list class="grey lighten-4">
                    <v-list-item>
                      <v-list-item-content>
                        <div
                          class="d-flex justify-space-between"
                        >
                          <span
                            class="blue-grey--text text--darken-2 text-uppercase"
                          >Laureates</span>
                          <v-icon class="accent--text" large>mdi-account-group-outline</v-icon>
                        </div>
                        <v-list-item-title class="d-flex justify-space-between">
                          <span
                            class="display-1 font-weight-light blue-grey--text text--darken-4 pb-n2"
                            :class="laureatesQty !== laureatesDefaultQty ? 'opacity-06' : null"
                          >{{ laureatesQty.toLocaleString('fr-FR') }}</span>
                          <table class="gender-qty">
                            <tr>
                              <td class="pr-4 text-center">
                                <span
                                  class="blue-grey--text text--darken-3"
                                  :class="malesQty !== malesDefaultQty ? 'opacity-06' : null"
                                >{{ malesQty.toLocaleString('fr-FR') }}</span><br>
                                <div class="caption mt-n1 text-subtitle">Males</div>
                              </td>
                              <td class="pl-4 text-center">
                                <span
                                  class="blue-grey--text text--darken-3"
                                  :class="femalesQty !== femalesDefaultQty ? 'opacity-06' : null"
                                >{{ femalesQty.toLocaleString('fr-FR') }}</span><br>
                                <div class="caption mt-n1 text-subtitle">Females</div>
                              </td>
                            </tr>
                          </table>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-card-text>
                    <v-list>
                      <div class="text-h6 primary-title primary--text mb-2">Most Recent Winners</div>
                      <v-list-item
                        v-for="item in laureates" :key="item.id"
                        link
                        exact
                        :to="{ name: 'laureates.edit', params: { id: item.id } }"
                      >
                        <v-list-item-action class="list-avatar d-flex justify-center">
                          <img
                            v-if="item.image"
                            :src="`${baseURL}/img/laureates/64/${item.image}`"
                          >
                          <v-avatar v-else color="blue-grey lighten-5">
                            <span class="blue-grey--text text--darken-1">
                              {{ item | fullName | capitalizeName }}
                            </span>
                          </v-avatar>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ item | fullName }}</v-list-item-title>
                          <v-list-item-subtitle class="caption">Updated {{ moment(item.updated_at).format('L') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-btn
                    link
                    :to="{ name: 'laureates.create' }"
                    absolute
                    dark
                    fab
                    bottom
                    right
                    color="primary"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card>
              </v-hover>
            </v-flex>

            <v-flex sm12 md4 class="px-2 my-4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="secondary-top-border info-card"
                  style="width: 100%"
                  :elevation="hover ? 10 : 2"
                  link
                  :to="{ name: 'users.index' }"
                  exact
                  v-ripple="false"
                >
                  <v-list class="grey lighten-4">
                    <v-list-item>
                      <v-list-item-content>
                        <div
                          class="d-flex justify-space-between"
                        >
                          <span
                            class="blue-grey--text text--darken-2 text-uppercase"
                          >Users</span>
                          <v-icon color="accent" large>mdi-account-multiple-outline</v-icon>
                        </div>
                        <v-list-item-title>
                          <span
                            class="display-1 font-weight-light pb-n2"
                          >{{ usersQty.toLocaleString('fr-FR') }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-card-text>
                    <v-list>
                      <div class="text-h6 primary-title primary--text mb-2">Recent Registered Users</div>
                      <v-list-item
                        v-for="item in users" :key="item.id"
                        :disabled="!item.invite"
                        link
                        exact
                        :to="{ name: 'users.edit', params: { id: item.invite ? item.invite.id : item.id } }"
                      >
                        <v-list-item-action class="list-avatar d-flex justify-center">
                          <img
                            v-if="item.image"
                            :src="`${baseURL}/img/users/64/${item.image}`"
                          >
                          <v-avatar v-else color="blue-grey lighten-5">
                            <span class="blue-grey--text text--darken-1">
                              {{ item | fullName | capitalizeName }}
                            </span>
                          </v-avatar>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ item | fullName }}</v-list-item-title>
                          <v-list-item-subtitle class="caption">Updated {{ moment(item.updated_at).format('L') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-btn
                    link
                    :to="{ name: 'users.create' }"
                    absolute
                    dark
                    fab
                    bottom
                    right
                    color="primary"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',

  components: {
    Loader
  },

  data () {
    return {
      awards: [],
      awardsDefaultQty: 0,
      awardsQty: 0,
      femalesDefaultQty: 0,
      femalesQty: 0,
      interval: false,
      laureates: [],
      laureatesDefaultQty: 0,
      laureatesQty: 0,
      malesDefaultQty: 0,
      malesQty: 0,
      pageLoaded: false,
      users: [],
      usersDefaultQty: 0,
      usersQty: 0
    }
  },

  mounted () {
    if (!this.isAdmin) {
      this.$router.push({ name: 'awards.edit', params: { id: this.user.award.id } })
    } else {
      Promise.all([
        this.getData()
      ])
        .then(() => {
          this.pageLoaded = true

          clearInterval(this.interval)

          if (this.awardsDefaultQty === this.awardsQty) {
            return
          }

          this.interval = window.setInterval(function () {
            if (this.awardsQty !== this.awardsDefaultQty) {
              let change = (this.awardsDefaultQty - this.awardsQty) / 10
              change = change >= 0 ? Math.ceil(change) : Math.floor(change)
              this.awardsQty = this.awardsQty + change
            }

            if (this.laureatesQty !== this.laureatesDefaultQty) {
              let change = (this.laureatesDefaultQty - this.laureatesQty) / 10
              change = change >= 0 ? Math.ceil(change) : Math.floor(change)
              this.laureatesQty = this.laureatesQty + change
            }

            if (this.malesQty !== this.malesDefaultQty) {
              let change = (this.malesDefaultQty - this.malesQty) / 10
              change = change >= 0 ? Math.ceil(change) : Math.floor(change)
              this.malesQty = this.malesQty + change
            }

            if (this.femalesQty !== this.femalesDefaultQty) {
              let change = (this.femalesDefaultQty - this.femalesQty) / 10
              change = change >= 0 ? Math.ceil(change) : Math.floor(change)
              this.femalesQty = this.femalesQty + change
            }

            if (this.usersQty !== this.usersDefaultQty) {
              let change = (this.usersDefaultQty - this.usersQty) / 10
              change = change >= 0 ? Math.ceil(change) : Math.floor(change)
              this.usersQty = this.usersQty + change
            }
          }.bind(this), 10)
        })
    }
  },

  computed: {
    ...mapGetters([
      'isAdmin',
      'user'
    ])
  },

  methods: {
    getData () {
      return this.$http.get('/dashboard')
        .then(({ data }) => {
          this.awards = data.awards
          this.awardsDefaultQty = data.awardsQty

          this.laureates = data.laureates
          this.laureatesDefaultQty = data.laureatesQty

          this.femalesDefaultQty = data.femalesQty
          this.malesDefaultQty = data.malesQty

          this.users = data.users
          this.usersDefaultQty = data.usersQty
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
    cursor: pointer;
  }

  .gender-qty tr td:first-child {
    border-right: 1px solid rgba(0,0,0,.12);
  }

  .info-cards >>> .elevation-2,
  .info-cards >>> .elevation-10 {
    transition: .3s;
  }

  .hero-img {
    background-image: linear-gradient(rgba(23,122,151,0.8),rgba(23,122,151,0.8)), url(../assets/img/auth-layout-bg.png);
    background-size: cover;
    background-position: center;
    height: 240px;
  }

  .list-avatar {
    width: 36px;
  }

  .list-avatar img {
    max-height: 36px;
    max-width: 36px;
    vertical-align: middle;
  }

  .list-avatar >>> .v-avatar {
    height: 36px !important;
    min-width: 36px !important;
    width: 36px !important;
  }

  .info-card {
    height: 96%;
  }
</style>
